
<section class="container-fluid">
  <div class="row">
    <div class="col-12 pl-4 pr-4">
      <div class="row ">
        <div class="divisionLocalidad col-12 ">
          <div class="tituloLocalidad shadow ">
            <mat-icon class="float-right rounded  mt-1 ml-2 mr-2  botonesCerrar" (click)="cerrar()"> cancel_presentation
            </mat-icon>
            <h3><strong> Carrito de compras </strong>
              <br>

            </h3>
            
            <h4 class="contador">
              <strong>Tiempo para realizar la compra: <countdown [config]="{leftTime:240}"></countdown> </strong>
            </h4>
            {{referenceCode}}
          </div>

          <div class="">
  
           
            <div class="  eventoFondo carrito   fondoBlanco border " *ngFor="let boleta of boletas">
              <h5 class="pl-md-4 pt-4"><strong>Evento: </strong>{{boleta?.nombreEvento}}</h5>
              <h5 class="pl-md-4 "><strong>Localidad: </strong> {{boleta.localidadNombre}}</h5>

              <h5 class="pl-md-4"><strong *ngIf="boleta.seccionSilla">Silla: </strong>{{boleta.seccionSilla}}</h5>
              <h5 class="pl-md-4"><strong>Precio: </strong> {{boleta?.precio| currency:'COP'}} + <strong>Servicio:
                </strong> {{boleta?.servicio| currency:'COP'}} + <strong>IVA: </strong> {{boleta?.servicioIva |
                currency:'COP'}}</h5>
              <h5 class="pl-md-4  pb-4"><strong>Valor: </strong> {{boleta?.precio + boleta?.servicio + boleta?.servicioIva
                | currency:'COP'}}</h5>
            </div>



            <div class="col-12 border " *ngIf="palco.id!=null">
              <h5 class="pt-4 pl-md-4"><strong>Evento: </strong>{{palco?.nombreEvento}}</h5>
              <h5 class="pl-md-4"><strong>Localidad: </strong> {{palco.nombre}}</h5>
              <h5 class="pl-md-4 "><strong>Palco No:</strong> {{palco.numeroDentroDeEvento}}</h5>
              <h5 class="pl-md-4"><strong>Personas por palco:</strong> {{palco.personasMaximas}}</h5>
              <h5 class="pl-md-4 "><strong>Precio: </strong> {{palco?.precio| currency:'COP'}} + <strong>Servicio:
                </strong> {{palco?.servicio| currency:'COP'}} + <strong>IVA</strong> {{palco?.servicioIva|currency:'COP'}}</h5>
              <h5 class="pl-md-4 pb-4"><strong>Valor Total: </strong>{{palco?.precio + palco?.servicio + palco?.servicioIva|currency:'COP'}}</h5>
            </div>

            <div class="fondoBlanco shadow col-12">
              <h5 class="pt-5 pl-md-4 pr-5">
                <strong>Valor Total:</strong> {{valorTotal |currency:'COP'}}
                <br>

                <strong *ngIf="boletas?.length>0">Cantidad de Tickets:</strong> {{boletas?.length}}
                <strong *ngIf="palco.id!=null">Cantidad de Palcos: 1</strong>


              </h5>
              <div class="pl-md-4 pb-5 mt-3">
            


                <button class="btn action_button" *ngIf="boletas" (click)="pagarBoletas()">Pagar</button>
                <button class="btn action_button" *ngIf="palco.id!=null " (click)="pagarPalco()">Pagar</button>  

                 

              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</section>